{
  "forgottenPassword": {
      "resetPassword": "Reset password",
      "enterEmailAddressAssociatedWithYourAccount": "Enter the email address associated with your account",
      "emailAddress": {
          "label": "Gebruikers-ID *",
          "placeholder": "Gebruikers-ID"
      },
      "enterValidEmail": "Please enter a valid email.",
      "passwordResetEmailSent":"Er wordt een nieuw wachtwoord verzonden naar het standaard e-mailadres dat is opgeslagen op het hoofdkantoor van RINGFOTO. Volg de instructies in de e-mail.",
      "passwordResetSuccess": "U kunt nu inloggen met uw nieuwe wachtwoord."
  },
  "updateEmailForm": {
    "newEmailAddress": {
      "label": "Nieuw E-mail adres",
      "placeholder": "E-mail adres"
    },
    "confirmNewEmailAddress": {
      "label": "Nieuw E-mail adres bevestigen",
      "placeholder": "E-mail adres"
    },
    "enterValidEmail": "Please enter a valid email.",
    "bothEmailMustMatch": "Both emails must match",
    "password": {
      "label": "Wachtwoord",
      "placeholder": "Wachtwoord"
    },
    "pleaseInputPassword": "Please input password",
    "emailUpdateSuccess": "Succes. Meld u aan met {{ newUid }}"
  }
}
